import { Component, NgZone } from '@angular/core';
import { NavController, Platform, Events } from 'ionic-angular';
import { FirebaseListObservable } from "angularfire2";

import { Databaseservice } from "../../providers/databaseservice";

import { ProductPage } from "../product/product";


@Component({
    selector: 'page-nearby',
    templateUrl: 'nearby.html'
})
export class NearbyPage {

    accounts: FirebaseListObservable<any[]>;

    zone: any;

    constructor(public navCtrl: NavController, public db: Databaseservice, private platform: Platform, public events: Events) {
        this.accounts = this.db.listAccounts();
        this.zone = new NgZone({ enableLongStackTrace: false });
    }

    openProduct(item: FirebaseListObservable<any>) {
        this.navCtrl.push(ProductPage, {
            item: item
        });
    }

    ionViewDidLoad() {
        this.platform.ready().then(
            () => {
                console.log('Platform Ready');
            });
    }

}



// WEBPACK FOOTER //
// ./src/pages/nearby/nearby.ts